module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="flex-sect">\r\n  <div class="container-width">\r\n\r\n    <div class="flex-chapter">II. Introduction\r\n    </div>\r\n    <div id="text-introduction" class="flex-desc">This CM&S study utilizes an electromagnetic (EM) and circuit\r\n      co-simulation methodology\r\n      based on the finite element method (FEM).  The EM simulations included a mathematical model of a realistic MRI\r\n      birdcage transmit body-coil tuned at the ' +
((__t = ( inputs.SimSetup.Frequency_Tesla )) == null ? '' : __t) +
' T hydrogen Larmor\r\n      frequency of ' +
((__t = ( inputs.SimSetup.Frequency )) == null ? '' : __t) +
' MHz, and a gel phantom as described in the\r\n      American Society for Testing Materials (ASTM) standard F2182-19e2 [1]. The ASTM phantom is typically used in MRI\r\n      safety\r\n      evaluation of implants with known electrical and physical properties [2]. This study was based on the model\r\n      presented by ' +
((__t = ( inputs.Author.Publication )) == null ? '' : __t) +
' [2].\r\n    </div>\r\n    <div class="flex-editable">Add text (optional)</div>\r\n\r\n  </div>\r\n</section>';

}
return __p
}